import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ItemSide from './item-side/ItemSide'

class OrderDesign extends Component {
    _handleDeleteItem = () => {
        const {onDeleteItem, barcode} = this.props

        onDeleteItem(barcode)
    }

    render() {
        const {preview_image, barcode} = this.props

        return (
            <div className='DesignFront text-center position-relative'>
                <i className="fa fa-close" onClick={this._handleDeleteItem}/>
                <label className="font-weight-bold">{barcode}</label>
                <ItemSide preview_image={preview_image}/>
            </div>
        )
    }
}

OrderDesign.defaultProps = {
    preview_image: '',
}

OrderDesign.propTypes = {
    preview_image: PropTypes.string,
    barcode: PropTypes.string.isRequired,
    onDeleteItem: PropTypes.func.isRequired
}

export default OrderDesign
